/**
 * Non Post Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getOrderWithIdAction,
  updateOrderStatusActions,
  updateOrderActions,
  getLogsAction,
} from '../orders/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectLogs,
} from '../orders/selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import JalaliUtils from '@date-io/jalaali';

import theme from '../../theme';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Grid,
  Button,
  IconButton,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiPencilOutline,
  mdiClose,
  mdiPrinter,
  mdiPackageVariant,
  mdiReceipt,
  mdiMapMarkerCheckOutline,
  mdiPackageVariantClosed,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiTruckFastOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiEmail,
} from '@mdi/js';

// Components
import Can from '../../components/Can';

// Helper
import {
  translate,
  convertPersianDigit2English,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import handleNotfication from '../../utils/handleNotfication';

// Type
import { Status } from '../orders/interfaces';
import { SelectorProps, Props } from '../orderDetails/interfaces';
import { Link } from 'react-router-dom';
import OrderChildList from '../postOrder3PLDetails/orderChildList';
import { DatePicker, MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import { Card } from '@material-ui/core';
import { CardHeader } from '@material-ui/core';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import ListOrderItems from './list';
import handleError from '../../utils/handleError';
import orderItemsRepository from 'client-sdk/src/Repository/order-items.repository';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import InfoCard from './infocard';
import { getAllTicket } from '../../api/ticket/get';


// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      marginBottom: '8px',
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: '10px',
      flex: 0.5,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    submitbtn: {
      border: 'none',
      backgroundColor: '#DFA01F',
      padding: '8px',
      color: '#fff',
      borderRadius: '5px',
      fontWeight: 600,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#c9911e',
      },
      width: '100%'
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      marginBottom: '14px',
      overflow: 'visible !important',
      padding: '14px',
      paddingBottom: '0',
      '@media (max-width: 768px)': {
        overflow: 'auto',
      }
    },
    contentBox: {
      marginTop: '-1px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '14px',
      fontWeight: 500,
      textAlign: 'right',
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },

    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paperHistory: {
      alignItems: 'center',
    },
  })
);

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};
const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

export function NonPostOrderDetails(props: Props) {
  const authContext = useContext(AuthContext);
  const [orderItems, setOrderItems] = useState([]);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openDelaySMS, setOpenDelaySMS] = useState(
    false as boolean
  );
  const [oldTicket, setOldTicket] = useState(null)
  const [delayTime, setDelayTime] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const classes = useStyles();

  useEffect(() => {
    const { id } = props.match.params;
    props.orderWithIdActionDispatch(id);
    props.getLogsDispatch(id);
    getOrderItems({ 'orderId.equals': id, size: 1000 });
    getOldTicket()
  }, []);

  const changeStatusOrder = () => {
    const { id } = props.match.params;
    props.updateOrderStatusDispatch({
      id: props.order.id,
      body: previewState.replace(/"/g, ''),
      pagination: {},
      callback: () => props.orderWithIdActionDispatch(id),
    });
    handleClose();
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const handleCloseDelaySMS = () => {
    setDelayTime(null)
    setOpenDelaySMS(false)
  };

  const getOrderItems = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const response = await orderItemsRepository.getAllOrderItems({ payload });
      setOrderItems(response.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getOldTicket = async () => {
    try {
      const res = await getAllTicket({linkId: props.match.params.id, linkType: 'order'})
      setOldTicket(res.data.content[0])
    } catch (error) {
      handleError(error)
    }
  }

  const sendSMS = async () => {
    const { id } = props.match.params;
    const payload = { id, body: `"` + delayTime.slice(-5) + `"` }
    try {
      await ordersRepository.sendDelayDeliveryOrderTimeSms({ payload })
      handleCloseDelaySMS()
      handleNotfication("پیامک با موفقیت ارسال شد", "success")
    } catch (err) {
      handleError(err)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{props.order.id}</span>
      </div>

      <Grid
        container
        direction="row-reverse"
        spacing={3}
        style={{ marginRight: '-45px' }}
      >

        <Can
          perform="orderDetail:print"
          role={authContext.user.role}
          yes={() => (
            <Link
              to={`/orders/receipts/${props.order.id}`}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                  authContext.user.role === 'WAREHOUSE_ADMIN'
                  ? 'چاپ رسید'
                  : 'چاپ حواله'}
              </Button>
            </Link>
          )}
        />
        <Can
          perform="orderExit:print"
          role={authContext.user.role}
          yes={() => (
            <Link
              to={`/orders/exit-receipts/${props.order.id}`}
              target="_blank"
              style={{
                textDecoration: 'none',
                margin: '0px 10px',
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiReceipt} size={1} />}
              >
                {'چاپ رسید خروج'}
              </Button>
            </Link>
          )}
        />
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Icon path={mdiEmail} size={1} />}
          onClick={() => setOpenDelaySMS(true)}
          style={{
            textDecoration: 'none',
            marginRight: '10px',
          }}
        >
          {'پیامک تاخیر'}
        </Button>
        {oldTicket && <Link to={`/ticketing/${oldTicket.id}`}>
          <Button
            variant="contained"
            color="primary"
            // startIcon={<Icon path={mdiEmail} size={1} />}
            onClick={() => setOpenDelaySMS(true)}
          >
            سابقه تیکت
          </Button>
        </Link>}

      </Grid>
      <Grid container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px', marginTop: '32px' }}>
        <InfoCard order={props.order} />
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2} >
          {props.order.childOrders?.length > 0 && (
            <Card>

              <CardHeader title={
                <Typography>
                  لیست سفارش های زیر مجموعه سفارش {props.order.id}
                </Typography>

              } />


              <Grid>
                <OrderChildList data={props.order.childOrders} />
              </Grid>
            </Card>




          )}
          <Card style={{ paddingTop: '0' }}>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              props.order?.items && (
                <>
                  <ListOrderItems
                    data={orderItems}
                  />
                </>
              )
            )}
          </Card>
          <Card style={{ marginTop: '16px' }}>
            <Grid item xs={12}>
              <Timeline align="left" style={{ minWidth: '500px' }}>
                {props.logs
                  ?.slice()
                  .reverse()
                  .map((log, index: number) => (
                    <TimelineItem
                      className={classes.missingOppositeContent}
                      key={index}
                    >
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            backgroundColor: colorStatus[log.newStatus],
                            border: index === 0 ? 'solid 4px #DF9234' : '',
                          }}
                        >
                          <Icon path={iconStatus[log.newStatus]} size={1} />
                        </TimelineDot>
                        {index !== props.logs?.length - 1 ? (
                          <TimelineConnector />
                        ) : (
                          ''
                        )}
                      </TimelineSeparator>
                      <TimelineContent className={classes.paperHistory}>
                        <div style={{ padding: '10px' }}>
                          <div className={classes.contentBox}>
                            <div style={{ flex: 1.5, textAlign: 'right' }}>
                              <span className={classes.contentlabel}>
                                وضعیت سفارش:
                              </span>
                              <span data-cy="status">
                                {translate(log.newStatus, 'order')}
                              </span>
                              {
                                log.newStatus === 'NOT_DELIVERED' && <p data-cy="status">
                                  {log.description}
                                </p>
                              }
                              {
                                log.newStatus === 'BUNDLED' && <p data-cy="status">
                                  {log.driverName}
                                </p>
                              }
                            </div>
                            <div
                              style={{
                                flex: 2,
                                textAlign: 'right',
                                justifyContent: 'center',
                              }}
                            >
                              <span className={classes.contentlabel}>
                                کاربر:
                              </span>
                              <Can
                                role={authContext.user.role}
                                perform="user-name:dontShowInLogs"
                                no={() => (
                                  <>
                                    <span>{log.modifierName}</span>
                                    <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                                  </>
                                )}
                              />
                              <span data-cy="role">
                                {translate(log.modifierRole, 'user')}
                              </span>
                            </div>
                            <Typography component="div" style={{ flex: 1 }}>
                              {log.time &&
                                jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                  .locale('fa')
                                  .format('jYYYY/jMM/jDD - HH:mm')}
                            </Typography>
                          </div>
                        </div>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
              </Timeline>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(props.order.status, 'order')}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'order')}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDelaySMS}
        onClose={handleCloseDelaySMS}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              // className={classes.closeButton}
              onClick={handleCloseDelaySMS}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
              <TimePicker
                fullWidth
                label={"زمان"}
                variant="inline"
                ampm={false}
                format="HH:mm"
                className={classes.textInput}
                autoOk
                clearable
                labelFunc={date =>
                  date?.isValid() ? date.format('HH:mm') : ''
                }
                value={delayTime}
                name="delayTime"
                id="delayTime"
                onChange={value => {
                  return setDelayTime(
                    value &&
                    convertPersianDigit2English(
                      value.format('jYYYY/jMM/jDD HH:mm')
                    )
                  );
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleCloseDelaySMS}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={sendSMS}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  order: makeSelectOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateOrderDispatch: payload => {
      dispatch(updateOrderActions(payload));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(NonPostOrderDetails);
